import { IntendedFor, NotPastExamsStudentsTypes } from "utils/constants";
import { Grid } from "@mui/material";
import { Button, NumberInput, RadioButtonGroupInput, SelectInput } from "react-admin";
import CloseIcon from "@mui/icons-material/Close";
import { useFormContext, useWatch } from "react-hook-form";
import { IntendedForChoices, NotPastExamsStudentsTypeChoices } from "utils/choices";
import SaveButtonIntention from "./SaveButtonIntention";

const IntendedForForm = ({ intendedFor, setIsEditIntended }) => {
  const filteredIntendedForChoices = IntendedForChoices.filter(choice => choice.id !== 3);
  const { setValue, getValues } = useFormContext();
  const intendedForNewValue = useWatch({ name: "intendedFor" });
  const type = useWatch({ name: "type" });

  const showRadioButton = intendedFor === IntendedFor.OnlyNotPastExamsStudents;
  const showSelect = intendedFor === IntendedFor.Regular;
  const showOnlyCapacity =
    intendedFor === IntendedFor.RegularAndNotPastExamsStudents ||
    intendedForNewValue === IntendedFor.RegularAndNotPastExamsStudents;

  const validateFacultyNumbers = value => {
    const from = Number(getValues("fromFacultyNumber"));
    const to = Number(getValues("toFacultyNumber"));
    if (from > to) {
      return "Началният факултетен номер не може да е по-голям от крайния";
    }
    return undefined;
  };

  return (
    <Grid
      container
      spacing={2}
    >
      {showSelect && (
        // (intendedFor === IntendedFor.RegularAndNotPastExamsStudents && record.studentsCapacity === 0 && (
        <Grid
          item
          xs={12}
          md={6}
        >
          <SelectInput
            source="intendedFor"
            label="Предназначен за"
            choices={filteredIntendedForChoices}
            emptyText={false}
          />
        </Grid>
      )}
      {showRadioButton && (
        <>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={6}
            >
              <RadioButtonGroupInput
                label="Добави по"
                source="type"
                choices={NotPastExamsStudentsTypeChoices}
                defaultValue={NotPastExamsStudentsTypeChoices[0].id || undefined}
                onChange={() => {
                  setValue("fromFacultyNumber", null);
                  setValue("toFacultyNumber", null);
                  setValue("studentsCapacity", null);
                }}
                sx={{ mb: 0, ml: 1 }}
              />
            </Grid>
          </Grid>
          {Number(type) === NotPastExamsStudentsTypes.FacultyNumbers ? (
            <>
              <Grid
                item
                xs={12}
                md={3}
              >
                <NumberInput
                  source="fromFacultyNumber"
                  label="от Факултетен номер"
                  validate={validateFacultyNumbers}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
              >
                <NumberInput
                  source="toFacultyNumber"
                  label="до Факултетен номер"
                  validate={validateFacultyNumbers}
                />
              </Grid>
            </>
          ) : (
            <Grid
              item
              xs={12}
              md={3}
            >
              <NumberInput
                source="studentsCapacity"
                label="Студентски капацитет"
              />
            </Grid>
          )}
        </>
      )}
      {showOnlyCapacity && (
        <Grid
          item
          xs={12}
          md={3}
        >
          <NumberInput
            source="studentsCapacity"
            label="Студентски капацитет"
          />
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sx={{ display: "flex", gap: 3 }}
      >
        <Button
          variant="outlined"
          startIcon={<CloseIcon />}
          color="error"
          size="small"
          label="Откажи"
          onClick={() => setIsEditIntended(false)}
        />
        <SaveButtonIntention setIsEditIntended={setIsEditIntended} />
      </Grid>
    </Grid>
  );
};

export default IntendedForForm;
